import React, { useEffect, useState } from "react";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Marquee from "../components/site/Marquee";
import BlogIndex from "../components/site/BlogIndex";
import Music from "../components/site/Music";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import { getProfile, getBlogs, getMusic } from "../lib/api";

export default function Home() {
  const [profile, setProfile] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [music, setMusic] = useState(null);

  useEffect(() => {
    getProfile().then(setProfile).catch(() => {});
    getBlogs().then(setBlogs).catch(() => {});
    getMusic().then(setMusic).catch(() => {});
  }, []);

  // handle deep-link hash after navigation from another route
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [profile]);

  return (
    <main data-testid="home-page">
      <Hero profile={profile} />
      <Marquee items={["Technology", "Finance", "Guitar", "Hindustani", "Marathons", "Sahyadris", "Stories"]} />
      <About profile={profile} />
      <BlogIndex blogs={blogs} />
      <Music music={music} />
      <Contact profile={profile} />
      <Footer profile={profile} />
    </main>
  );
}
